import localDB from "./localDB";

let GLOBAL = require('./globals');

const ProductCompoundData = {
    async list(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/product-compounds/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-compounds/${data.product}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-compound/${data.id}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-compound/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
};

export default ProductCompoundData;


// WEBPACK FOOTER //
// ./src/data/ProductCompoundData.js